export enum RouteNames {
  MAIN_PAGE = '',
  LOGIN_PAGE = 'login',
  FORBIDDEN_PAGE = 'forbidden',
  USER = 'user',
  CATALOGS_PAGE = 'catalogs',
  RESET_PASSWORD_PAGE = 'reset-password',
  REGISTER_PAGE = 'register',
  TOOLS = 'tools',
  HOME = 'home',
  ADMIN = 'admin',
}

export enum LessonsRouteNames {
  LESSONS = 'lessons',
  DETAILS = 'lessons/:id',
}

export enum WorkoutRouteNames {
  WORKOUTS = 'workouts',
  DETAILS = 'workouts/:id',
}
export enum OrganizationRouteNames {
  MAIN = 'organization',
  LIST = 'organization/list',
  DETAILS = 'organization/:id',
}

export enum FinanceRouteNames {
  FINANCE = 'finance',
}

export enum AccountingEntryNames {
  MAIN = 'accounting-entry',
  DETAILS = 'details',
  CREATE = 'create',
}

export enum BankPaymentNames {
  MAIN = 'bank-payment',
}

export enum ServiceNames {
  MAIN = 'service',
}
